import type { NewsItem } from "@/types";

export const newsCategories = ["全部", "行业动态", "新番介绍", "活动预告", "深度评测"];

export const newsList: NewsItem[] = [
  {
    id: "n1",
    title: "《星海回声》第二季官宣定档，全员回归开启新篇章",
    summary:
      "官方正式公布《星海回声》第二季将于本季新番档期开播，主视觉图与首支预告同步解禁，主角团队全员回归。",
    cover:
      "https://readdy.ai/api/search-image?query=Colorful%20anime%20key%20visual%20illustration%20of%20a%20young%20space%20explorer%20crew%20standing%20on%20a%20futuristic%20ship%20deck%20under%20a%20vivid%20nebula%2C%20clean%20flat%20cel%20shading%2C%20bright%20cheerful%20palette%2C%20soft%20gradient%20background%2C%20official%20poster%20style&width=800&height=500&seq=news-01&orientation=landscape",
    category: "新番介绍",
    source: "漫蛙资讯组",
    author: "青禾",
    date: "2026-10-15",
    content: [
      "备受期待的新番《星海回声》正式公布第二季将于本季新番档期开播。制作委员会同步公开了全新主视觉图与时长约九十秒的首支预告片，宣告主角团队全员回归。",
      "从预告片可以看到，第二季的故事将延续第一季末尾留下的悬念，主角一行人将驶向更深处的星域，面对新的伙伴与未知的挑战。画面演出较前作有明显升级，宇宙场景的光影表现尤为亮眼。",
      "官方表示，本季将继续由原班制作团队担纲，音乐部分也延续了前作的高水准。更多角色设定与播出详情将在后续陆续公开，感兴趣的朋友记得持续关注漫蛙官网的跟踪报道。",
    ],
  },
  {
    id: "n2",
    title: "秋季新番大盘点：这些作品值得加入你的追番清单",
    summary:
      "本季新番题材覆盖热血、日常、悬疑与治愈，我们从中挑选出十余部口碑与制作俱佳的作品，帮你快速锁定目标。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20season%20lineup%20illustration%20showing%20a%20grid%20of%20colorful%20character%20silhouettes%20from%20different%20genres%2C%20energetic%20flat%20cel%20shading%2C%20bright%20warm%20palette%2C%20clean%20studio%20background%2C%20editorial%20magazine%20cover%20style&width=800&height=500&seq=news-02&orientation=landscape",
    category: "新番介绍",
    source: "漫蛙资讯组",
    author: "小满",
    date: "2026-10-13",
    content: [
      "随着秋季档期全面铺开，本季新番的数量与题材丰富度都相当可观。热血战斗、温馨日常、悬疑推理与治愈系作品各有代表作，追番的选择前所未有地多。",
      "我们综合制作阵容、前作口碑与已播出的前几集表现，整理出一份值得优先关注的清单。其中既有大制作的续作，也有原创企划带来的惊喜。",
      "需要注意的是，追番节奏因人而异。建议先看前两集感受风格，再决定是否长期跟进。漫蛙作品库已同步收录本季新番与往季佳作，方便你分类浏览。",
    ],
  },
  {
    id: "n3",
    title: "《青空料理帖》漫画累计发行突破两千万册",
    summary:
      "温暖治愈的料理题材漫画《青空料理帖》宣布系列累计发行量正式突破两千万册，官方发布纪念插画感谢读者。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cozy%20anime%20illustration%20of%20a%20small%20sunlit%20kitchen%20with%20steaming%20home%20cooked%20dishes%20and%20a%20smiling%20chef%20character%2C%20soft%20flat%20cel%20shading%2C%20gentle%20cream%20and%20green%20palette%2C%20clean%20background%2C%20wholesome%20editorial%20style&width=800&height=500&seq=news-03&orientation=landscape",
    category: "行业动态",
    source: "漫蛙资讯组",
    author: "林岚",
    date: "2026-10-11",
    content: [
      "以家常料理与日常温情为主题的漫画《青空料理帖》近日宣布，系列累计发行量正式突破两千万册，成为近年料理题材作品中表现最亮眼的一部。",
      "为纪念这一里程碑，作者特别绘制了全新纪念插画，并附上简短感言，感谢一路陪伴的读者。漫画将进入全新的「四季食记」篇章，延续一贯的治愈基调。",
      "业内分析认为，该作的成功在于把美食描写与人物成长自然融合，让读者在轻松的阅读中获得抚慰，这也是它能够长线畅销的重要原因。",
    ],
  },
  {
    id: "n4",
    title: "漫蛙线下嘉年华活动预告：周末三天，等你来玩",
    summary:
      "漫蛙线下嘉年华公布活动日程，现场设有作品主题展区、创作者见面会与限定周边贩售，为期三天的活动免费向公众开放。",
    cover:
      "https://readdy.ai/api/search-image?query=Vibrant%20anime%20convention%20illustration%20of%20a%20festive%20exhibition%20hall%20with%20colorful%20banners%20and%20cheerful%20visitor%20characters%2C%20flat%20cel%20shading%2C%20lively%20green%20and%20orange%20accents%2C%20clean%20modern%20poster%20style&width=800&height=500&seq=news-04&orientation=landscape",
    category: "活动预告",
    source: "漫蛙活动组",
    author: "阿泽",
    date: "2026-10-09",
    content: [
      "漫蛙线下嘉年华正式公布活动日程，将于本周末连续举办三天。现场规划了作品主题展区、创作者见面会以及限定周边贩售区，内容相当丰富。",
      "活动期间，多部人气作品的原画与设定集将首次公开展出，观众可以近距离欣赏到创作背后的细节。见面会环节则有创作者现场交流与签名安排。",
      "本次活动免费向公众开放，采取分时段入场方式以控制人流。建议提前规划到访时间，并关注官方渠道发布的最新安排。",
    ],
  },
  {
    id: "n5",
    title: "深度评测：《雾都侦探社》如何把推理讲得又稳又燃",
    summary:
      "作为本季口碑黑马，《雾都侦探社》在推理结构与人物弧光上都交出了漂亮答卷。本文从叙事与演出两个维度展开分析。",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20anime%20illustration%20of%20a%20detective%20standing%20on%20a%20misty%20city%20street%20at%20dusk%20with%20gaslamps%2C%20dramatic%20flat%20cel%20shading%2C%20deep%20teal%20and%20amber%20palette%2C%20clean%20atmospheric%20background%2C%20mystery%20poster%20style&width=800&height=500&seq=news-05&orientation=landscape",
    category: "深度评测",
    source: "漫蛙评测室",
    author: "顾川",
    date: "2026-10-07",
    content: [
      "在众多新番之中，《雾都侦探社》凭借扎实的剧本与稳定的演出，成为本季讨论度最高的黑马之一。它没有依赖夸张的设定，而是把重心放在推理的扎实与人物的可信上。",
      "从叙事来看，每一集的案件都服务于主线，线索布置克制而有迹可循，观众能够跟着角色一起思考。人物弧光也处理得细腻，主角的犹豫与成长贯穿始终。",
      "演出方面，制作组擅长用环境与光影营造氛围，配合恰到好处的配乐，把冷静的推理过程拍出了紧张感。综合来看，这是一部值得慢慢品味的作品。",
    ],
  },
  {
    id: "n6",
    title: "《银月骑士团》剧场版公布先导视觉图",
    summary:
      "人气系列《银月骑士团》宣布推出全新剧场版动画，官方放出的先导视觉图以月夜下的骑士团为核心意象。",
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20anime%20illustration%20of%20a%20group%20of%20knights%20silhouetted%20under%20a%20giant%20moon%20with%20flowing%20capes%20and%20floating%20petals%2C%20flat%20cel%20shading%2C%20silver%20blue%20and%20gold%20palette%2C%20dramatic%20clean%20background%2C%20cinematic%20poster%20style&width=800&height=500&seq=news-06&orientation=landscape",
    category: "新番介绍",
    source: "漫蛙资讯组",
    author: "青禾",
    date: "2026-10-05",
    content: [
      "人气系列《银月骑士团》正式宣布将推出全新剧场版动画。官方同步公开了先导视觉图，以月夜下的骑士团剪影为核心意象，气势十足。",
      "据制作方透露，剧场版将采用全新的故事线，在保留系列世界观的基础上加入更多舞台化的演出设计，动作场面也会有明显升级。",
      "目前剧场版的具体上映档期尚未公布，更多声优阵容与预告内容将在后续陆续释出。",
    ],
  },
  {
    id: "n7",
    title: "原创动画《四月信笺》开播，治愈系叙事获好评",
    summary:
      "本季原创动画《四月信笺》以书信串起两代人的故事，清新的画风与克制的叙事赢得观众一致好评。",
    cover:
      "https://readdy.ai/api/search-image?query=Soft%20healing%20anime%20illustration%20of%20a%20girl%20writing%20a%20letter%20by%20an%20open%20window%20with%20cherry%20petals%20drifting%20in%2C%20gentle%20flat%20cel%20shading%2C%20pastel%20pink%20and%20sage%20green%20palette%2C%20clean%20airy%20background%2C%20tender%20editorial%20style&width=800&height=500&seq=news-07&orientation=landscape",
    category: "新番介绍",
    source: "漫蛙资讯组",
    author: "小满",
    date: "2026-10-03",
    content: [
      "本季原创动画《四月信笺》正式开播，作品以书信为线索，串联起两代人跨越时空的情感故事，风格清新而克制。",
      "与许多强调戏剧冲突的作品不同，《四月信笺》更愿意把镜头留给日常的细节：窗边的风、未寄出的信、缓慢展开的回忆。这种叙事节奏反而让情感更显真实。",
      "目前已播出的几集在观众中收获了不少好评，被认为是一部适合安静观看、慢慢体会的作品。",
    ],
  },
  {
    id: "n8",
    title: "漫蛙平台作品库上线「主题合集」功能",
    summary:
      "为了帮助用户更快发现感兴趣的内容，漫蛙作品库新增主题合集功能，按题材与风格对作品进行精选归类。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20collection%20illustration%20of%20stacked%20fanned%20poster%20cards%20with%20various%20characters%20and%20a%20magnifying%20glass%2C%20flat%20cel%20shading%2C%20fresh%20green%20and%20grey%20palette%2C%20clean%20minimal%20background%2C%20product%20feature%20style&width=800&height=500&seq=news-08&orientation=landscape",
    category: "行业动态",
    source: "漫蛙产品组",
    author: "林岚",
    date: "2026-10-01",
    content: [
      "为了帮助用户更快发现感兴趣的内容，漫蛙作品库近日上线了全新的「主题合集」功能，按题材与风格对作品进行精选归类。",
      "首批合集涵盖「治愈日常」「热血冒险」「悬疑推理」等方向，每个合集都由编辑精选代表作品，并附上一段导读，方便你快速了解合集的定位。",
      "未来我们将持续扩充合集数量，也欢迎通过反馈入口告诉我们你希望看到哪些主题。",
    ],
  },
  {
    id: "n9",
    title: "声优访谈：为新角色注入灵魂的创作幕后",
    summary:
      "我们邀请到本季人气作品的几位主要声优，聊聊他们如何在录音棚里揣摩角色、把握情绪与节奏。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20anime%20illustration%20of%20a%20recording%20studio%20microphone%20with%20sound%20waves%20and%20a%20friendly%20voice%20actor%20character%2C%20flat%20cel%20shading%2C%20soft%20green%20and%20cream%20palette%2C%20clean%20studio%20background%2C%20interview%20editorial%20style&width=800&height=500&seq=news-09&orientation=landscape",
    category: "深度评测",
    source: "漫蛙采访组",
    author: "顾川",
    date: "2026-09-28",
    content: [
      "声优的表演往往决定了一个角色能否真正「活」起来。本期我们邀请到本季人气作品的几位主要声优，聊聊录音棚里的创作过程。",
      "谈到揣摩角色，几位声优都提到「先理解动机，再决定语气」的方法。他们会在正式录音前，反复推敲角色在每一场戏里的心理状态。",
      "对于如何把握节奏，大家的共识是与画面保持呼吸感——既不抢戏，也不拖沓，让声音自然融入演出之中。",
    ],
  },
  {
    id: "n10",
    title: "《夜航少年》漫画宣布动画化，冬季档期首播",
    summary:
      "悬疑冒险漫画《夜航少年》正式宣布动画化，将于冬季档期首播，官方同步放出概念预告与制作阵容。",
    cover:
      "https://readdy.ai/api/search-image?query=Atmospheric%20anime%20illustration%20of%20a%20boy%20on%20a%20small%20boat%20under%20a%20starry%20night%20sky%20with%20glowing%20constellations%2C%20flat%20cel%20shading%2C%20deep%20navy%20and%20teal%20palette%2C%20clean%20dreamy%20background%2C%20adventure%20poster%20style&width=800&height=500&seq=news-10&orientation=landscape",
    category: "新番介绍",
    source: "漫蛙资讯组",
    author: "青禾",
    date: "2026-09-25",
    content: [
      "悬疑冒险漫画《夜航少年》正式宣布动画化，预计将于冬季档期首播。官方同步放出了概念预告片与主要制作阵容。",
      "原作以「夜航」为核心意象，讲述一名少年在星夜航行中追寻真相的旅程，融合了冒险、悬疑与成长元素，拥有稳定的读者群。",
      "制作方表示将尽力还原原作分镜中的氛围感，尤其是夜色与星光的演出。更多细节有待后续公布。",
    ],
  },
  {
    id: "n11",
    title: "动画配乐专题：那些让人一听就想起剧情的旋律",
    summary:
      "优秀的配乐是动画的灵魂之一。本期专题盘点近年来令人印象深刻的动画原声，聊聊音乐如何推动情绪。",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20anime%20illustration%20of%20musical%20notes%20and%20piano%20keys%20floating%20over%20a%20soft%20gradient%20sky%20with%20glowing%20lines%2C%20flat%20cel%20shading%2C%20warm%20amber%20and%20green%20palette%2C%20clean%20abstract%20background%2C%20music%20editorial%20style&width=800&height=500&seq=news-11&orientation=landscape",
    category: "深度评测",
    source: "漫蛙评测室",
    author: "小满",
    date: "2026-09-22",
    content: [
      "配乐常常是决定一部动画「记忆点」的关键。一段恰到好处的旋律，能让观众在多年之后依然瞬间想起某段剧情。",
      "本期专题盘点了近年几部以配乐见长的作品，从主题曲到场景音乐，聊聊作曲者是如何用音符去塑造节奏与情绪的。",
      "值得一提的是，许多优秀的配乐并不追求复杂的编排，而是用简单的动机反复变奏，把观众的情绪一点点推向高潮。",
    ],
  },
  {
    id: "n12",
    title: "《春日野营》第三季制作决定，露营日常继续",
    summary:
      "治愈露营题材作品《春日野营》宣布第三季制作决定，主创团队原班回归，继续带来温暖的户外日常。",
    cover:
      "https://readdy.ai/api/search-image?query=Peaceful%20anime%20illustration%20of%20friends%20camping%20by%20a%20lake%20at%20golden%20hour%20with%20a%20tent%20and%20campfire%2C%20flat%20cel%20shading%2C%20warm%20green%20and%20golden%20palette%2C%20clean%20nature%20background%2C%20cozy%20editorial%20style&width=800&height=500&seq=news-12&orientation=landscape",
    category: "新番介绍",
    source: "漫蛙资讯组",
    author: "阿泽",
    date: "2026-09-19",
    content: [
      "以露营为主题的治愈系作品《春日野营》正式宣布第三季制作决定，主创团队原班回归，将继续带来温暖轻松的户外日常。",
      "前两季凭借舒缓的节奏与细腻的自然描写积累了良好口碑，观众普遍表示作品能带来「深呼吸」般的放松感。",
      "第三季预计将解锁更多新的露营地点与季节风景，具体播出安排有待后续公布。",
    ],
  },
  {
    id: "n13",
    title: "行业观察：原创动画企划为何越来越受关注",
    summary:
      "近年来原创动画企划数量稳步上升。本文从创作自由度与市场反馈两个角度，解读这一变化的背后逻辑。",
    cover:
      "https://readdy.ai/api/search-image?query=Conceptual%20anime%20illustration%20of%20a%20glowing%20lightbulb%20above%20storyboards%20and%20character%20sketches%20on%20a%20desk%2C%20flat%20cel%20shading%2C%20fresh%20green%20and%20grey%20palette%2C%20clean%20minimal%20background%2C%20analytical%20editorial%20style&width=800&height=500&seq=news-13&orientation=landscape",
    category: "行业动态",
    source: "漫蛙资讯组",
    author: "顾川",
    date: "2026-09-16",
    content: [
      "近几年来，原创动画企划的数量呈现稳步上升的趋势。相比改编自既有IP的作品，原创企划在题材与叙事上拥有更高的自由度。",
      "从市场反馈看，优秀的原创作品往往能带来更强的话题性，因为它们没有原作框架的束缚，观众也无法提前预知剧情走向。",
      "当然，原创也意味着更高的风险。如何在自由创作与观众接受度之间取得平衡，仍是每一位创作者需要面对的课题。",
    ],
  },
  {
    id: "n14",
    title: "漫蛙用户调研结果公布：大家最爱看什么类型",
    summary:
      "我们统计了近期的用户浏览偏好，从题材、时长到更新节奏，看看动漫爱好者们真实的追番习惯。",
    cover:
      "https://readdy.ai/api/search-image?query=Clean%20anime%20illustration%20of%20a%20colorful%20bar%20chart%20and%20pie%20chart%20made%20of%20friendly%20character%20icons%2C%20flat%20cel%20shading%2C%20bright%20green%20and%20orange%20palette%2C%20minimal%20background%2C%20data%20report%20editorial%20style&width=800&height=500&seq=news-14&orientation=landscape",
    category: "行业动态",
    source: "漫蛙产品组",
    author: "林岚",
    date: "2026-09-13",
    content: [
      "为了更了解大家的真实偏好，我们开展了本季度的用户浏览调研，从题材、作品时长到更新节奏等维度收集了反馈。",
      "结果显示，治愈日常与热血冒险是最受欢迎的两大方向，二者在浏览占比上几乎持平；悬疑推理则呈现出更高的单次停留时长。",
      "在更新节奏上，多数用户更偏好稳定的周更，认为这样更利于持续追番。感谢每一位参与调研的朋友，我们会把这些反馈带入后续的内容建设。",
    ],
  },
  {
    id: "n15",
    title: "《玻璃花与纸飞机》OVA 特别篇公开正式预告",
    summary:
      "青春群像作品《玻璃花与纸飞机》推出 OVA 特别篇，正式预告公开，讲述本篇之外的一段夏日回忆。",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20anime%20illustration%20of%20teenagers%20flying%20paper%20planes%20on%20a%20summer%20school%20rooftop%20with%20clear%20blue%20sky%2C%20flat%20cel%20shading%2C%20soft%20blue%20and%20green%20palette%2C%20clean%20nostalgic%20background%2C%20youth%20poster%20style&width=800&height=500&seq=news-15&orientation=landscape",
    category: "活动预告",
    source: "漫蛙资讯组",
    author: "小满",
    date: "2026-09-10",
    content: [
      "青春群像作品《玻璃花与纸飞机》宣布推出 OVA 特别篇，并公开了正式预告。特别篇将讲述本篇之外的一段夏日回忆。",
      "预告片中定格了许多充满年代感的场景：天台、纸飞机、蝉鸣与放学后的走廊，整体氛围怀旧而清澈。",
      "特别篇将作为系列的重要补充，为几位配角的过往补上关键的一笔，喜欢本篇的观众不要错过。",
    ],
  },
];